import React from 'react'
import Footer from '../Components/Footer'
import Header from '../Components/Header'
import { Helmet } from "react-helmet-async";


export default function Contact() {
  return (
   <>
   <Helmet>
    <title>Contact Us | Gandhi Mandela Foundation</title>
    <meta name="description" content="Get in touch with the Gandhi Mandela Foundation for inquiries, partnerships, and collaborations." />
   </Helmet>
   <Header />
   
      <div>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Contact Us</span>
          </div>
          <h1>Contact Us</h1>
        </div>
      </section>
      {/* =========================
        CONTACT SECTION---*/}
      <section className="section">
        <div className="container">
          <div className="grid grid-2">
            {/* Contact Info */}
            <div className="fade-in visible">
              <h2 style={{fontSize: 30, marginBottom: 15}}>
                Get In Touch With Us
              </h2>
              <div style={{marginTop: 30}}>
                <div style={{display: 'flex', gap: 15, marginBottom: 25}}>
                  <i className="fa-solid fa-phone" style={{fontSize: 22, color: '#d4a843', marginTop: 4}} />
                  <div>
                    <h4>Phone Number</h4>
                    <p style={{color: 'var(--muted)'}}>
                      +91 11 3530 1996
                    </p>
                  </div>
                </div>
                <div style={{display: 'flex', gap: 15, marginBottom: 25}}>
                  <i className="fa-solid fa-location-dot" style={{fontSize: 22, color: '#d4a843', marginTop: 4}} />
                  <div>
                    <h4>Office Address</h4>
                    <p style={{color: 'var(--muted)'}}>
                      511, Naurang House, K.G. Marg New Delhi, India.
                    </p>
                  </div>
                </div>
                <div style={{display: 'flex', gap: 15, marginBottom: 25}}>
                  <i className="fa-solid fa-envelope" style={{fontSize: 22, color: '#d4a843', marginTop: 4}} />
                  <div>
                    <h4>Email Address</h4>
                    <p style={{color: 'var(--muted)'}}>
                      info@gandhimandelafoundation.com
                    </p>
                  </div>
                </div>
              </div>
              <div className="social-icons" style={{marginTop: 20}}>
                <a href="https://www.facebook.com/gandhimandelafoundation" target="_blank"><i className="fa-brands fa-facebook-f" /></a>
                <a href="https://www.instagram.com/gandhimandelafoundation/" target="_blank"><i className="fa-brands fa-instagram" /></a>
                <a href="https://twitter.com/GMFoundationInd" target="_blank"><i className="fa-brands fa-x-twitter" /></a>
                <a href="https://www.linkedin.com/company/gandhimandelafoundation" target="_blank"><i className="fa-brands fa-linkedin-in" /></a>
              </div>
            </div>
            {/* Google Map */}
             <section className="contact-map">
              <div className="map-wrapper">
                <iframe
                  title="Gandhi Mandela Foundation"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.057941219244!2d77.217769388855!3d28.628025500000042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd0b9d7f542f%3A0x3c9d1735278021c0!2sNaurang%20House!5e0!3m2!1sen!2sin!4v1782477515143!5m2!1sen!2sin" width={600} height={300} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="strict-origin-when-cross-origin"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </section>
          </div>
        </div>
      </section>
      {/* =========================
    Contact end-*/}
    <Footer />
    </div>

   </>
  )
}
